import {
    get,
    put,
    post,
    Delete,
    formDataPost
} from "../ApiDecorator"; // 倒入 api

const Paired = {
    // 获取全部结对空间
    getListByProject(data) {
        return get("/course/spx/listByProject", data);
    },
    // 获取我的结对空间
    getListByOwner(data) {
        return get("/course/spx/listByOwner", data);
    },
    // 空间管理-课表列表（spaceIds 数组：spaceIds=1&spaceIds=2）
    getCourseList(data) {
        return get("/learn/spx/schedule/scheduleRowsBySpaceIds", data);
    },
}

export default Paired